module.exports = __webpack_public_path__ + "img/leads - grayscale.f7586e91.svg";